import { Box, CardContent, Divider, Stack, Typography } from '@mui/material';
import { ChartLine } from 'lucide-react';
import { useIntl } from 'react-intl';

import CommonDashboardCard from '../commonDashboardCard';
import Sparkline from '../sparkline';
import { formatDuration } from '../../../../utils/statisticsDashboard';

export default function PerformanceCard({ data = [] }) {
  const intl = useIntl();

  function renderSparkline(item, index) {
    return (
      <Box key={item.id}>
        <Box sx={{ py: 1.5 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              mb: 0.75,
              fontSize: '.8rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.title}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              width: '100%',
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                flex: '1.55 1 0',
                minWidth: 0,
              }}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  color: '#173663',
                  fontSize: '1.7rem',
                  lineHeight: 1.15,
                }}
              >
                {item.value}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  mt: 0.25,
                  fontSize: '.7rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {item.description}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flex: '1.9 1 0',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 1,
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  flex: '1 1 135px',
                  minWidth: 0,
                }}
              >
                <Sparkline
                  data={item.chartData}
                  color={item.color}
                  height={44}
                  gradientId={`performance-gradient-${item.id}`}
                  tooltipValueFormatter={formatDuration}
                  tooltipLabelName={null}
                />
              </Box>

              <Stack
                direction="column"
                alignItems="flex-start"
                justifyContent="center"
                spacing={0.5}
                sx={{
                  flex: '0.9 1 120px',
                  minWidth: 0,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '.8rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.variation}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '.7rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.variationText}
                </Typography>
              </Stack>
            </Box>
          </Box>
        </Box>

        {index < data.length - 1 && <Divider />}
      </Box>
    );
  }

  return (
    <CommonDashboardCard
      cardHeaderProps={{
        title: intl.formatMessage({
          id: 'dashboard.new.operation.performance.title',
        }),
        hasDivider: true,
        icon: (
          <ChartLine
            size={24}
            color="#2fba67"
            absoluteStrokeWidth
          />
        ),
      }}
      hasInfo
    >
      <CardContent
        sx={{
          py: 0,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        {data.map(renderSparkline)}
      </CardContent>
    </CommonDashboardCard>
  );
}
